/* Yuhive 2026-09 改版：卡片数量加减、一键加购（多款式弹出选款）、收藏夹（存本机浏览器）、懒加载商品条。 */
(function () {
  if (window.YH) return;
  var YH = (window.YH = {});
  var WKEY = "yh_wish";
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function money(c) { return "$" + (Number(c || 0) / 100).toFixed(2); }
  function img(u, w) { if (!u) return ""; u = u.indexOf("//") === 0 ? "https:" + u : u; return u + (u.indexOf("?") > -1 ? "&" : "?") + "width=" + (w || 400); }
  function getWish() { try { var a = JSON.parse(localStorage.getItem(WKEY) || "[]"); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function setWish(a) { try { localStorage.setItem(WKEY, JSON.stringify(a.slice(0, 100))); } catch (e) {} paintWish(); }
  function paintWish() {
    var a = getWish();
    document.querySelectorAll("[data-wish]").forEach(function (b) { var on = a.indexOf(b.getAttribute("data-wish")) > -1; b.classList.toggle("on", on); b.setAttribute("aria-pressed", on ? "true" : "false"); });
    document.querySelectorAll(".yh-wishn").forEach(function (n) { n.textContent = a.length ? "(" + a.length + ")" : ""; });
  }
  YH.paintWish = paintWish;

  /* 提示条 */
  var toastT;
  function toast(html) {
    var t = document.querySelector(".yh-toast");
    if (!t) { t = document.createElement("div"); t.className = "yh-toast"; t.setAttribute("role", "status"); document.body.appendChild(t); }
    t.innerHTML = html; t.classList.add("show"); clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove("show"); }, 3200);
  }
  function freeLine(c) {
    var left = 1500 - (c.total_price || 0);
    return left > 0 ? "<small style=\"display:block;font-weight:500;opacity:.85\">$" + (left / 100).toFixed(2) + " more for free US shipping</small>" : "<small style=\"display:block;font-weight:500;opacity:.85\">Your order ships free to the US</small>";
  }
  function setCartCount() {
    return fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) {
      try { document.dispatchEvent(new CustomEvent("yh:cart", { detail: c })); } catch (e) {}
      document.querySelectorAll(".yh-mnav em[data-cart]").forEach(function (n) { n.textContent = c.item_count || ""; });
      document.querySelectorAll(".yh-cartn,.phh-cartn").forEach(function (n) { n.textContent = "(" + c.item_count + ")"; }); document.querySelectorAll(".yh-cartn-m").forEach(function (n) { n.textContent = c.item_count; });
      return c;
    }).catch(function () { return null; });
  }
  function addToCart(id, qty) {
    return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: [{ id: Number(id), quantity: Math.max(1, qty | 0) }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || "Could not add"); return j; }); })
      .then(function (j) { return setCartCount().then(function (c) { toast("<span>✓ Added to cart" + (c ? freeLine(c) : "") + "</span><a href=\"/cart\">View cart</a>"); return j; }); });
  }
  YH.addToCart = addToCart;
  function qtyOf(el) { var box = el.closest(".yh-card-buy,.yh-qd-row"); var i = box && box.querySelector(".yh-qty input"); var v = i ? parseInt(i.value, 10) : 1; return v > 0 ? v : 1; }

  /* 选款弹窗 */
  var qd, qp, qsel;
  function openQuick(handle, qty) {
    if (!qd) {
      qd = document.createElement("div"); qd.className = "yh-qd"; qd.setAttribute("role", "dialog"); qd.setAttribute("aria-modal", "true");
      qd.innerHTML = '<div class="yh-qd-box"><button class="yh-qd-x" type="button" aria-label="Close">×</button><div class="yh-qd-img"><img alt=""></div><div class="yh-qd-main"></div></div>';
      document.body.appendChild(qd);
      qd.addEventListener("click", function (e) { if (e.target === qd || e.target.closest(".yh-qd-x")) closeQuick(); });
    }
    qd.querySelector(".yh-qd-main").innerHTML = '<div class="yh-skel" style="aspect-ratio:auto;height:220px"></div>';
    qd.classList.add("open"); document.documentElement.style.overflow = "hidden";
    fetch("/products/" + encodeURIComponent(handle) + ".js").then(function (r) { return r.json(); }).then(function (p) { qp = p; renderQuick(qty); }).catch(function () { location.href = "/products/" + handle; });
  }
  function closeQuick() { if (qd) qd.classList.remove("open"); document.documentElement.style.overflow = ""; }
  function optList(p) {
    return (p.options || []).map(function (o, i) { return typeof o === "string" ? { name: o, values: uniq(p.variants.map(function (v) { return v.options[i]; })) } : { name: o.name, values: o.values }; });
  }
  function uniq(a) { return a.filter(function (x, i) { return a.indexOf(x) === i; }); }
  function findVariant() { return qp.variants.filter(function (v) { return qsel.every(function (s, i) { return v.options[i] === s; }); })[0]; }
  function renderQuick(qty) {
    var p = qp, opts = optList(p); var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    qsel = first.options.slice();
    var h = "<h3>" + esc(p.title) + '</h3><div class="yh-qd-price"></div>';
    if (!(opts.length === 1 && opts[0].values.length === 1 && /default/i.test(opts[0].values[0]))) {
      opts.forEach(function (o, i) {
        h += '<div class="yh-qd-opt"><label>' + esc(o.name) + ': <span data-oi="' + i + '"></span></label><div class="yh-qd-vals">';
        o.values.forEach(function (val) { h += '<button type="button" data-oi="' + i + '" data-ov="' + esc(val) + '">' + esc(val) + "</button>"; });
        h += "</div></div>";
      });
    }
    h += '<div class="yh-qd-row"><div class="yh-qty"><button type="button" data-q="-1" aria-label="Less">−</button><input type="number" min="1" value="' + (qty || 1) + '" aria-label="Quantity"><button type="button" data-q="1" aria-label="More">+</button></div><button class="yh-qd-add" type="button">Add to cart</button></div>';
    h += '<a class="yh-qd-link" href="' + esc(p.url || "/products/" + p.handle) + '">View full details ›</a>';
    qd.querySelector(".yh-qd-main").innerHTML = h;
    paintQuick();
  }
  function paintQuick() {
    var v = findVariant(), m = qd.querySelector(".yh-qd-main");
    m.querySelectorAll(".yh-qd-vals button").forEach(function (b) {
      var i = +b.getAttribute("data-oi"), val = b.getAttribute("data-ov");
      b.classList.toggle("sel", qsel[i] === val);
      var test = qsel.slice(); test[i] = val;
      var ok = qp.variants.some(function (x) { return x.available && test.every(function (s, k) { return x.options[k] === s; }); });
      b.classList.toggle("na", !ok);
    });
    m.querySelectorAll("label span[data-oi]").forEach(function (s) { s.textContent = qsel[+s.getAttribute("data-oi")] || ""; });
    m.querySelector(".yh-qd-price").textContent = v ? money(v.price) : "Unavailable";
    var src = (v && v.featured_image && v.featured_image.src) || qp.featured_image || (qp.images && qp.images[0]);
    qd.querySelector(".yh-qd-img img").src = img(src, 600);
    var add = m.querySelector(".yh-qd-add"); add.disabled = !(v && v.available); add.textContent = v && v.available ? "Add to cart" : "Sold out";
  }

  /* 收藏夹抽屉 */
  var wd;
  function openWish() {
    if (!wd) {
      wd = document.createElement("div"); wd.className = "yh-wd"; wd.setAttribute("role", "dialog"); wd.setAttribute("aria-label", "Wishlist");
      wd.innerHTML = '<div class="yh-wd-bg"></div><div class="yh-wd-panel"><div class="yh-wd-h"><b>My Wishlist</b><button type="button" aria-label="Close">×</button></div><div class="yh-wd-list"></div></div>';
      document.body.appendChild(wd);
      wd.addEventListener("click", function (e) {
        if (e.target.classList.contains("yh-wd-bg") || e.target.closest(".yh-wd-h button")) { wd.classList.remove("open"); return; }
        var rm = e.target.closest("[data-unwish]"); if (rm) { setWish(getWish().filter(function (h) { return h !== rm.getAttribute("data-unwish"); })); fillWish(); }
      });
    }
    wd.classList.add("open"); fillWish();
  }
  function fillWish() {
    var list = wd.querySelector(".yh-wd-list"), a = getWish();
    if (!a.length) { list.innerHTML = '<div class="yh-wd-empty">Your wishlist is empty.<br>Tap the ♡ on any product to save it here.</div>'; return; }
    list.innerHTML = a.map(function () { return '<div class="yh-skel" style="aspect-ratio:auto;height:64px;margin:10px 0"></div>'; }).join("");
    Promise.all(a.slice(0, 40).map(function (h) { return fetch("/products/" + encodeURIComponent(h) + ".js").then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }))
      .then(function (ps) {
        list.innerHTML = ps.map(function (p, i) {
          if (!p) return '<div class="yh-wd-it"><div></div><div style="font-size:13px;color:#9aa0a6">No longer available</div><button type="button" data-unwish="' + esc(a[i]) + '">Remove</button></div>';
          return '<div class="yh-wd-it"><a href="' + esc(p.url) + '"><img src="' + esc(img(p.featured_image, 160)) + '" alt=""></a><div><a href="' + esc(p.url) + '">' + esc(p.title) + '</a><div class="p">' + (p.price_varies ? "From " : "") + money(p.price_min || p.price) + '</div></div><button type="button" data-unwish="' + esc(p.handle) + '">Remove</button></div>';
        }).join("");
      });
  }

  /* 懒加载商品条（新品/热销：按时间或销量排好序的整店商品，用分区渲染取回） */
  function loadStrip(el) {
    if (el.dataset.loaded) return; el.dataset.loaded = "1";
    fetch(el.getAttribute("data-yh-strip")).then(function (r) { return r.text(); }).then(function (html) {
      var d = document.createElement("div"); d.innerHTML = html; var g = d.querySelector(".yh-grid");
      if (g) { el.innerHTML = g.innerHTML; paintWish(); } else { el.closest(".yh-block") && (el.closest(".yh-block").style.display = "none"); }
    }).catch(function () { el.closest(".yh-block") && (el.closest(".yh-block").style.display = "none"); });
  }
  function initStrips() {
    var els = document.querySelectorAll("[data-yh-strip]");
    if (!("IntersectionObserver" in window)) { els.forEach(loadStrip); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); loadStrip(e.target); } }); }, { rootMargin: "600px 0px" });
    els.forEach(function (e) { io.observe(e); });
  }

  document.addEventListener("click", function (e) {
    var q = e.target.closest(".yh-qty button[data-q]");
    if (q) { e.preventDefault(); var i = q.parentElement.querySelector("input"); i.value = Math.max(1, (parseInt(i.value, 10) || 1) + (+q.getAttribute("data-q"))); return; }
    var add = e.target.closest(".yh-add");
    if (add) {
      e.preventDefault(); var qty = qtyOf(add);
      if (add.getAttribute("data-multi")) { openQuick(add.getAttribute("data-handle"), qty); return; }
      add.classList.add("busy");
      addToCart(add.getAttribute("data-id"), qty).catch(function (err) { toast("✕ " + esc(err.message)); }).then(function () { add.classList.remove("busy"); });
      return;
    }
    var h = e.target.closest("[data-wish]");
    if (h) { e.preventDefault(); var k = h.getAttribute("data-wish"), a = getWish(), at = a.indexOf(k); if (at > -1) a.splice(at, 1); else { a.unshift(k); toast("♥ Saved to wishlist"); } setWish(a); return; }
    if (e.target.closest(".yh-wish-open")) { e.preventDefault(); openWish(); return; }
    if (qd && qd.classList.contains("open")) {
      var ob = e.target.closest(".yh-qd-vals button");
      if (ob) { qsel[+ob.getAttribute("data-oi")] = ob.getAttribute("data-ov"); if (!findVariant()) { var cand = qp.variants.filter(function (v) { return v.options[+ob.getAttribute("data-oi")] === ob.getAttribute("data-ov"); }); if (cand[0]) qsel = cand[0].options.slice(); } paintQuick(); return; }
      var qa = e.target.closest(".yh-qd-add");
      if (qa) { var v = findVariant(); if (!v) return; qa.disabled = true; addToCart(v.id, qtyOf(qa)).then(function () { closeQuick(); }).catch(function (err) { toast("✕ " + esc(err.message)); }).then(function () { qa.disabled = false; }); }
    }
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { closeQuick(); if (wd) wd.classList.remove("open"); } });

  /* 第二轮：最近看过（存本机浏览器，最多 12 个） */
  var RKEY = "yh_recent";
  function recentGet() { try { var a = JSON.parse(localStorage.getItem(RKEY) || "[]"); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function initRecent() {
    var pd = document.querySelector("[data-yh-product]"); var box = document.querySelector(".yh-recent");
    var cur = pd && pd.getAttribute("data-yh-product");
    var list = recentGet().filter(function (h) { return h && h !== cur; });
    if (cur) { try { localStorage.setItem(RKEY, JSON.stringify([cur].concat(list).slice(0, 12))); } catch (e) {} }
    if (!box || !list.length) return;
    var grid = box.querySelector(".yh-grid");
    Promise.all(list.slice(0, 6).map(function (h) { return fetch("/products/" + encodeURIComponent(h) + "?section_id=yh-pcard").then(function (r) { return r.ok ? r.text() : ""; }).catch(function () { return ""; }); }))
      .then(function (arr) {
        var html = arr.map(function (t) { var d = document.createElement("div"); d.innerHTML = t; var c = d.querySelector(".yh-card"); return c ? c.outerHTML : ""; }).join("");
        if (html) { grid.innerHTML = html; box.hidden = false; paintWish(); }
      });
  }

  /* 第二轮：商品页款式多时折叠 + 按名字找款 */
  function initSwatches() {
    var wrap = document.querySelector(".phd-swatches"); if (!wrap) return;
    var sws = wrap.querySelectorAll(".phd-sw"); if (sws.length <= 21) return;
    wrap.classList.add("yh-many");
    var tools = document.createElement("div"); tools.className = "yh-swtools";
    tools.innerHTML = (sws.length > 30 ? '<input type="search" placeholder="Find an option (e.g. gold, heart, 5)" aria-label="Find an option">' : "") + '<button type="button" aria-expanded="false">Show all ' + sws.length + " options</button>";
    wrap.parentNode.insertBefore(tools, wrap.nextSibling);
    var btn = tools.querySelector("button"), inp = tools.querySelector("input"), none = null;
    btn.addEventListener("click", function () { var o = wrap.classList.toggle("open"); btn.textContent = o ? "Show fewer" : "Show all " + sws.length + " options"; btn.setAttribute("aria-expanded", o ? "true" : "false"); });
    if (inp) inp.addEventListener("input", function () {
      var q = inp.value.trim().toLowerCase(), shown = 0;
      sws.forEach(function (b) { var ok = !q || (b.getAttribute("data-title") || "").toLowerCase().indexOf(q) > -1; b.style.display = ok ? "" : "none"; if (ok) shown++; });
      if (q) { wrap.classList.add("open"); btn.style.display = "none"; } else { wrap.classList.remove("open"); btn.style.display = ""; btn.textContent = "Show all " + sws.length + " options"; }
      if (!none) { none = document.createElement("div"); none.className = "yh-swnone"; wrap.parentNode.insertBefore(none, tools.nextSibling); }
      none.textContent = q && !shown ? "No option matches “" + inp.value + "”." : "";
    });
  }

  /* 第二轮：分类/搜索页按价格筛（保留排序等其他参数，换价格时回第 1 页） */
  function initPriceChips() {
    document.querySelectorAll(".yh-chips [data-gte],.yh-chips [data-lte],.yh-chips [data-all]").forEach(function (a) {
      var u = new URL(location.href); u.searchParams.delete("page"); u.searchParams.delete("filter.v.price.gte"); u.searchParams.delete("filter.v.price.lte");
      var g = a.getAttribute("data-gte"), l = a.getAttribute("data-lte");
      if (g) u.searchParams.set("filter.v.price.gte", g); if (l) u.searchParams.set("filter.v.price.lte", l);
      a.href = u.pathname + (u.search || "");
      var cur = new URL(location.href), cg = cur.searchParams.get("filter.v.price.gte") || "", cl = cur.searchParams.get("filter.v.price.lte") || "";
      var on = a.hasAttribute("data-all") ? (!cg && !cl) : ((g || "") === cg && (l || "") === cl);
      a.classList.toggle("on", on); if (on) a.setAttribute("aria-current", "true");
    });
  }

  /* 第二轮：购物车页免邮进度 */
  function paintCartBar(c) {
    var el = document.querySelector("[data-yh-cartbar] .yh-fbar"); if (!el || !c) return;
    var bar = el.parentNode; bar.hidden = !c.item_count;
    var left = 1500 - (c.total_price || 0), pct = Math.min(100, Math.round((c.total_price || 0) / 15));
    if (left > 0) { el.className = "yh-fbar"; el.innerHTML = "🚚 Add <b>$" + (left / 100).toFixed(2) + "</b> more of eligible items for FREE US shipping<i><u style=\"width:" + pct + "%\"></u></i>"; }
    else { el.className = "yh-fbar ok"; el.innerHTML = "🎉 Your order qualifies for <b>FREE US shipping</b> (heavy items excepted)"; }
  }
  document.addEventListener("yh:cart", function (e) { paintCartBar(e.detail); });
  function initCartBar() {
    if (!document.querySelector("[data-yh-cartbar]")) return;
    setCartCount(); var t;
    document.addEventListener("click", function (e) { if (e.target.closest("cart-items-component,.cart-items,form[action*='/cart'],[name='updates[]'],quantity-selector-component")) { clearTimeout(t); t = setTimeout(setCartCount, 900); } });
    document.addEventListener("change", function () { clearTimeout(t); t = setTimeout(setCartCount, 900); });
  }

  /* 第二轮：手机底部导航 */
  function initMnav() {
    var nav = document.querySelector(".yh-mnav"); if (!nav) return;
    document.body.classList.add("yh-has-mnav");
    nav.addEventListener("click", function (e) {
      if (e.target.closest("[data-mnav-search]")) { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); var i = document.querySelector('.yhh-search input[name="q"]'); if (i) setTimeout(function () { i.focus(); }, 250); }
      if (e.target.closest("[data-mnav-cats]")) { e.preventDefault(); window.scrollTo({ top: 0 }); var w = document.querySelector(".yhh-all"); if (w) { w.classList.add("open"); var b = w.querySelector(".yhh-all-btn"); if (b) b.setAttribute("aria-expanded", "true"); } }
    });
  }
  function boot() { paintWish(); initStrips(); initRecent(); initSwatches(); initPriceChips(); initCartBar(); initMnav(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();
